import t from '@rcm/i18n-client';
import noop from 'lodash/noop';
import React, { FormEvent, useCallback } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { submitShipping } from '../../actions';
import useShippingQueriesError from '../../hooks/useShippingQueriesError';
import { selectView } from '../../slices/view';
import { ViewID } from '../../types';
import Errors from '../shared/Errors';
import ShippingCityField from './ShippingCityField';
import ShippingCountryField from './ShippingCountryField';
import ShippingPostalCodeField from './ShippingPostalCodeField';
import ShippingStateField from './ShippingStateField';
import ShippingSubmitButton from './ShippingSubmitButton';

const ShippingForm = () => {
    const dispatch = useDispatch();
    const view = useSelector(selectView);
    const isError = useShippingQueriesError();

    const handleSubmit = useCallback((e: FormEvent) => {
        e.preventDefault();
        dispatch(submitShipping());
    }, [dispatch]);

    return <Modal show={view === ViewID.SHIPPING} onHide={noop}>
        <Form onSubmit={handleSubmit}>
            <Modal.Header>
                <Modal.Title as='h1'>
                    {t('Reliv Order Calculator')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>{
                isError ?
                    <Errors /> :
                <>
                    <Row className="mb-3">
                        <Form.Text as={Col}>
                            <h5>{t('Enter your address to get started.')}</h5>
                            <p>{t('We use this to calculate tax and shipping.')}</p>
                        </Form.Text>
                    </Row>
                    <ShippingCountryField />
                    <ShippingPostalCodeField />
                    <ShippingCityField />
                    <ShippingStateField />
                </>
            }</Modal.Body>
            {!isError && <Modal.Footer>
                <ShippingSubmitButton />
            </Modal.Footer>}
        </Form>
    </Modal>;
}

export default ShippingForm;
